import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Trash2, GripVertical } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

export default function SubtaskItem({
  subtask,
  isCompletedView,
  onToggle,
  onDelete,
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: subtask.id, disabled: isCompletedView });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? "#fff" : "transparent",
    boxShadow: isDragging ? "0 4px 14px rgba(0,0,0,0.08)" : "none",
    zIndex: isDragging ? 50 : "auto",
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-2 py-1.5 group/sub"
      data-testid={`subtask-${subtask.id}`}
    >
      {!isCompletedView && (
        <button
          type="button"
          {...attributes}
          {...listeners}
          className="drag-handle text-zinc-300 hover:text-zinc-600 opacity-100 md:opacity-0 md:group-hover/sub:opacity-100 transition-opacity"
          aria-label="Drag subtask"
          data-testid={`drag-subtask-${subtask.id}`}
        >
          <GripVertical className="w-3.5 h-3.5" strokeWidth={1.5} />
        </button>
      )}
      <Checkbox
        className="swiss-checkbox"
        checked={subtask.completed}
        onCheckedChange={(c) => onToggle(!!c)}
        disabled={isCompletedView}
        data-testid={`subtask-checkbox-${subtask.id}`}
      />
      <span
        className={`flex-1 text-sm ${
          subtask.completed ? "line-through text-zinc-400" : "text-zinc-700"
        }`}
      >
        {subtask.title}
      </span>
      {!isCompletedView && (
        <button
          type="button"
          onClick={onDelete}
          className="p-1 text-zinc-300 hover:text-red-600 opacity-100 md:opacity-0 md:group-hover/sub:opacity-100 transition-opacity"
          aria-label="Delete subtask"
          data-testid={`delete-subtask-${subtask.id}`}
        >
          <Trash2 className="w-3 h-3" strokeWidth={1.5} />
        </button>
      )}
    </li>
  );
}
